module.exports = __webpack_public_path__ + "img/cute_handdrawn_6.3d3c77f5.png";